import React, { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Checkbox,
  Typography,
  Tooltip,
  Box,
  TableSortLabel,
  IconButton
} from "@mui/material";
import RecordNotFound from "../../../common/RecordNotFound";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import { useForm } from "react-hook-form";
import AddPartType from "./AddPartType";
import { PART_TYPE_LISTING_COLUMNS } from "../../../utils/constant";
import {
  typeChangeStatusService,
  onEditTypeService,
  onAddTypeService,
} from "../../../services/PartTypeService";
import { yupResolver } from "@hookform/resolvers/yup";
import { ADD_PARTTYPE_VALIDATIONS } from "../../../utils/Validation";
import Add from "@mui/icons-material/Add";
import { visuallyHidden } from "@mui/utils";
import useGlobalState from "../../../Context";
import EditIcon from "@mui/icons-material/Edit";

const PartTypeList = ({
  handleTableChanges,
  fetchPartTypeDetails,
  totalElements,
  onSearchType,
  setLoading,
  showNotification,
  partTypeList,
  typeList,
  setPartTypeList,
  noRecord,
}) => {
  const [nameSearch, setNameSearch] = useState("");
  const [openAddUserDialog, setOpenAddUserDialog] = useState(false);
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [clearSearch, setClearSearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchedRows, setSearchedRows] = useState(partTypeList);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({});
  const [typeId, setTypeId] = useState(null);
  const [checked, setChecked] = useState(false);
  const [checkType, setCheckType] = useState();
  const [checkTypeOnEdit, setCheckTypeOnEdit] = useState();
  const [typeName, setTypeName] = useState();
  const [selected, setSelected] = useState([]);
  const [disableUpdateButton, setDisbaleUpdateButton] = useState(true);
  const [isUpdateButton, setIsUpdateButton] = useState(true);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [sortValue, setSortValue] = useState("ASC");
  const [isSearchBtnClick, setIsSearchBtnClick] = useState(false);
  const [{ auth }, dispatch] = useGlobalState();
  const loggedInUserInfo = auth.ldapParam;
  const [searchValue_, setsearchValue_] = useState(null);
  const [formValues, setFormValues] = useState({
    createdOn: new Date(),
    createdBy: loggedInUserInfo.userId,
    modifiedBy: loggedInUserInfo.userId,
  });

  const formOption = {
    resolver: yupResolver(ADD_PARTTYPE_VALIDATIONS),
    defaultValues: { ...formData },
  };

  const { register, handleSubmit, formState, reset,setValue } = useForm(formOption);
  const { errors } = formState;

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const handleTypeChange = (id, name) => {
    setCheckType(id);
    setTypeName(name);
    setCheckTypeOnEdit(id);
    if (id === 1) {
      setChecked(false);
    } else setChecked(true);
  };

  const handleClickOpen = (item) => {
    if (item) {
      reset(item);
    }
    setOpenAddUserDialog(true);
    setIsEditMode(true);
   
    setTypeId(item?.partTypeId);
    setFormValues({
      createdOn: item?.createdOn,
      createdBy: item?.createdBy,
      modifiedBy: item?.modifiedBy,
     active: item?.active ? true : false,
    });
    setFormData({ ...item });
  };

  const handleClickOpenOnAdd = async () => {
    setOpenAddUserDialog(true);
    //await fetchTypeList();
  };

  useEffect(() => {
    reset(formData);
    setCheckType();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openAddUserDialog]);

  const handleClose = () => {
    setOpenAddUserDialog(false);
    setIsEditMode(false);
    setIsUpdateButton(true);
    setChecked(false);
    setFormData({});
  };

  useEffect(() => {
    
    setSearchedRows(partTypeList);
  }, [nameSearch, partTypeList]);

  const handleChangeRowsPerPage = async (event) => {
    const paginationValues = {
      pageNumber: 0,
      pageSize: +event.target.value,
    };
    await handleTableChanges(paginationValues, false, sortValue, orderBy,searchValue_);
    setPage(0);
    setMaxPage(0);
    setRowsPerPage(+event.target.value);
  };

  const handleChangePage = async (event, newPage) => {
    if (newPage > page && newPage > maxPage) {
      setMaxPage(newPage);
      const paginationValues = {
        pageNumber: newPage,
        pageSize: rowsPerPage,
      };
      await handleTableChanges(paginationValues, true, sortValue, orderBy,searchValue_);
    }
    setPage(newPage);
  };

  const searchText = async (e) => {
    setSearchValue(e.target.value);
   
    setNameSearch("");
    e.target.value === "" ? setClearSearch(false) : setClearSearch(true);
    if (e.target.value === "") {
      onclickClear()
      // await fetchPartTypeDetails("name", true);
     
      // setPage(0);
      // setMaxPage(0);
    }
  };

  const searchOnClick = async (type) => {
    try {
      setLoading(true);
      
      const requestBody = {
        status: true,
        pageNumber: 0,
        pageSize: rowsPerPage ?? 10,
      
        search: searchValue && searchValue.trim(),
      };
      setsearchValue_(searchValue)
      setIsSearchBtnClick(true);
      setSelected([]);
      setDisbaleUpdateButton(true)
      await onSearchType(requestBody, searchValue && searchValue.trim());
      setPage(0);
      setMaxPage(0);
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
   setNameSearch(searchValue && searchValue.trim());
  };

  const onclickClear = async () => {
   
    const paginationObject = {
      pageNumber: 0,
      pageSize: rowsPerPage ?? 10,
     
    };
    setsearchValue_(null)
    setSelected([]);
    setDisbaleUpdateButton(true)
    await fetchPartTypeDetails("name", false,null,null,paginationObject);

    setNameSearch("");
    setSearchValue("");
    setPage(0);
    setMaxPage(0);
    setClearSearch(false);
    setIsSearchBtnClick(false);
  };

  const onAddEditTypeSubmit = async (data) => {
    try {
      let obj = {
        partTypeId: 0,
        origin: null,
        partTypeCode: data.partTypeCode && data.partTypeCode.trim(),
        name: data.name && data.name.trim(),
        sourceCode: null,
        active: formValues.active ? true : false,
        createdOn: formValues.createdOn,
        createdBy: formValues.createdBy,
        modifiedOn: formValues.createdOn,
        modifiedBy: formValues.modifiedBy,
      };
      const res = !isEditMode
        ? await onAddTypeService(obj)
        : await onEditTypeService(obj, typeId);
      if (res.statusCode == "6") {

        const newVendorList = [...partTypeList];
        const index = newVendorList.findIndex((x) => x.id === typeId);
        newVendorList[index] = { ...partTypeList[index], ...obj };
        setPartTypeList(newVendorList);

        handleClose(false);
        setIsUpdateButton(true);
        setSelected([]);
        setDisbaleUpdateButton(true)
        showNotification("Success", res.message, "success");
        // setNameSearch("");
        // setSearchValue("");
        setPage(0);
        setMaxPage(0);
        onclickClear()
        // let paginationObject = {
        //   pageSize:rowsPerPage ?? 10,
        //   pageNumber:0
        // }
       
        // await fetchPartTypeDetails("name", false,null,null,paginationObject);
       

      } else {
        handleClose(false);
        showNotification("Error", res.message, "error");
      }
    } catch (err) {
      handleClose(false);
      showNotification("Error", err, "error");
      throw err;
    }
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - partTypeList.length) : 0;

  const handleActiveChange = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
    if (newSelected.length !== 0) {
      setDisbaleUpdateButton(false);
    } else {
      setDisbaleUpdateButton(true);
    }
    const newSearchedRow = partTypeList.map((currentRow) => {
      if (currentRow.partTypeId === id) {
        return {
          ...currentRow,
          active: event.target.checked,
        };
      }
      return currentRow;
    });
    setPartTypeList(newSearchedRow);
  };

  const onChangeStatusSubmit = async () => {
    const resultRecords = [];
    selected.forEach((itemId) => {
      const tempItem = partTypeList.find((record) => record.partTypeId === itemId);
      if (tempItem) {
        resultRecords.push({
          active: tempItem.active,
          partTypeId: tempItem.partTypeId,
        });
      }
    });
    try {
      const res = await typeChangeStatusService(resultRecords);
      if (res.statusCode == "6") {
        // await fetchPartTypeDetails("name", true);
        setSelected([]);
        showNotification("Success", res.message, "success");
        setDisbaleUpdateButton(true);
      } else {
        showNotification("Error", res.message, "error");
      }
    } catch (e) {
    } finally {
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    const paginationObject = {
      pageNumber: 0,
      pageSize:rowsPerPage?rowsPerPage: 10,
    };
    setSelected([]);
    setDisbaleUpdateButton(true)
    fetchPartTypeDetails(property, isAsc, searchValue_ && searchValue_.trim(),null,paginationObject);
    setSortValue(isAsc ? "DESC" : "ASC");
    setPage(0);
    setMaxPage(0);
    
  };

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 7 }}>
        <Grid container spacing={2} sx={{ px: 0 }} display="flex">
          <Grid item xs={6} md={4}>
            <Typography
              align="left"
              sx={{ mr: "auto", color: "#003f93" }}
              variant="h6"
            >
              Part Type ( {totalElements ? totalElements : 0} )
            </Typography>
          </Grid>
          <Grid item xs={6} md={8}>
            <Typography align="right">
              <div className="searchContainer">
              
                <input
                  type="text"
                  placeholder="Search by Name"
                  onChange={searchText}
                  className="searchInput2"
                  value={searchValue}
                />
                <IconButton disabled={searchValue === ""}  className={searchValue === "" ? 'searchIcon':'filPrimaryColor searchIcon'}>
                <SearchIcon
                  //className="searchIcon"
                  onClick={() => searchOnClick("firstName")}
                />
                </IconButton>
                {clearSearch && (
                  <ClearIcon
                    sx={{ fontSize: "22px", color: "red" }}
                    className="searchClear"
                    onClick={onclickClear}
                  />
                )}
              </div>
              <Tooltip title="Add Type">
                <Button
                  variant="contained"
                  onClick={() => {
                    handleClickOpenOnAdd();
                  }}
                  sx={{ ml: 1 }}
                  className="button-primary-alt-contained"
                  startIcon={<Add />}
                >
                  Add Part Type
                </Button>
              </Tooltip>
              <Tooltip title="Update Type Status">
                <span>
                <Button
                  variant="contained"
                  sx={{ ml: 1 }}
                  className="button-primary-alt-contained"
                  onClick={onChangeStatusSubmit}
                  disabled={disableUpdateButton}
                >
                  Status Update
                  {selected.length !== 0 &&
                    ` (${Object.keys(selected).length})`}
                </Button>
                </span>
              </Tooltip>
            </Typography>
          </Grid>
          <Grid item xs={12} mb={4} sx={{ mt: 2 }}>
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer sx={{ maxHeight: 720 }}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  // sx={{ minWidth: 750 }}
                  aria-labelledby="tableTitle"
                  size="small"
                >
                  <EnhancedTableHead
                    numSelected={selected.length}
                    rowCount={searchedRows.length}
                    onRequestSort={handleRequestSort}
                    order={order}
                    orderBy={orderBy}
                  />
                  {searchedRows && searchedRows.length > 0 ? (
                    <TableBody sx={{ mt: 2 }}>
                      {searchedRows
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => {
                          const isItemSelected = isSelected(row.partTypeCode);
                          const labelId = `enhanced-table-checkbox-${index}`;
                          return (
                            <TableRow
                              hover
                              tabIndex={-1}
                              role="checkbox"
                              aria-checked={isItemSelected}
                              selected={isItemSelected}
                              key={index}
                            >
                              <TableCell size="small" key={"code"}>
                                {row["partTypeCode"] ?? "-"}
                              </TableCell>
                              <TableCell size="small" key={"name"}>
                                {row["name"] ?? "-"}
                              </TableCell>
                              <TableCell align="left">
                                {" "}
                                <Checkbox
                                  color="primary"
                                  checked={(isItemSelected, row.active)}
                                  classes={{root: 'custom-checkbox-root'}}
                                  onClick={(event) =>
                                    handleActiveChange(event, row.partTypeId)
                                  }
                                  inputProps={{
                                    "aria-labelledby": labelId,
                                  }}
                                />
                              </TableCell>
                              <TableCell>
                                <EditIcon
                                  sx={{ fontSize: "20px", cursor: "pointer",color:'#567aac' , height: "18px", 
                                  width: "18px"}}
                                  // className="brandSearchClear"
                                  onClick={() => handleClickOpen(row)}
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      {emptyRows > 0 && (
                        <TableRow
                          style={{
                            height: 33 * emptyRows,
                          }}
                        >
                          <TableCell colSpan={5} />
                        </TableRow>
                      )}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        {noRecord ? (
                          <TableCell colSpan={5}>
                            <RecordNotFound />
                          </TableCell>
                        ) : (
                          <TableCell colSpan={5} />
                        )}
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
              {searchedRows && searchedRows.length > 0 ? (
                <TablePagination
                  className="newPagination"
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  component="div"
                  count={totalElements}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              ) : null}
            </Paper>
            <AddPartType
              openDialog={openAddUserDialog}
              handleClose={handleClose}
              typeList={typeList}
              register={register}
              errors={errors}
              formData={formData}
              onAddEditTypeSubmit={onAddEditTypeSubmit}
              handleSubmit={handleSubmit}
              isEditMode={isEditMode}
              handleChange={handleChange}
              checked={checked}
              checkType={checkType}
              handleTypeChange={handleTypeChange}
              checkTypeOnEdit={checkTypeOnEdit}
              isUpdateButton={isUpdateButton}
              setIsUpdateButton={setIsUpdateButton}
              setValue = {setValue}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default PartTypeList;

function EnhancedTableHead({ onRequestSort, order, orderBy }) {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow key={"1"}>
        {PART_TYPE_LISTING_COLUMNS.map((headCell) => (
          <TableCell
            size="small"
            variant="head"
            className="tableHeader"
            sx={{ pt: 1.5, pb: 1.5 }}
            key={headCell.userId}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            style={{
              minWidth: headCell.minWidth,
              // backgroundColor: "lightgray",
              fontWeight: "bold",
              color: "#003A6B",
            }}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              disabled={
                (headCell.id === "action" ||
                  headCell.id === "active") &&
                true
              }
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
